import { Injectable } from "@angular/core";
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment'; 
import { URL_MAP } from "../../shared/urlMap";

@Injectable({
  providedIn: 'root'
})
export class ReferidosService {
    private readonly apiUrl = `${environment.HOST}${URL_MAP.API.REFERIDOS}`;
    private readonly apiBeneficiariosUrl = `${environment.HOST}${URL_MAP.API.BENEFICIARIOS_REFERIDOS}`;

    constructor(
        private httpClient: HttpClient,
    ) {}

    public getReferidosPorAsesor(codigoAsesor: string): Observable<any> {
        const body = {
            nombreClave: "getRfdxAsesor",
            jsonParametros: JSON.stringify({ pty_id_asesor: codigoAsesor })
        };

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': '*/*',
                'Content-Type': 'application/json'
            })
        };

        return this.httpClient.post<any>(this.apiUrl, body, httpOptions).pipe(
            map(response => {
                if (response?.status) {
                    return response.data;
                } else {
                    throw new Error('Error en la respuesta del servicio de referidos');
                }
            }),
            catchError((error: HttpErrorResponse) => {
                console.error('Error al obtener los referidos:', error);
                return throwError(() => error);
            })
        );
    }

    public getBeneficiariosPorReferidos(documento: string): Observable<any> {
        const body = {
            nombreClave: "getRfdxContratante",
            jsonParametros: JSON.stringify({ pty_id_contratante: documento})
        };

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': '*/*',
                'Content-Type': 'application/json'
            })
        };

        return this.httpClient.post<any>(this.apiBeneficiariosUrl, body, httpOptions).pipe(
            map(response => {
                if (response?.status) {
                    return response.data;
                } else {
                    throw new Error('Error en la respuesta del servicio de referidos');
                }
            }),
            catchError((error: HttpErrorResponse) => {
                console.error('Error al obtener los referidos:', error);
                return throwError(() => error);
            })
        );
    }
}